import { useState } from 'react';
import { IconSearch, IconX } from './Icons';

interface SearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
  initial?: string;
  autoFocus?: boolean;
}

export default function SearchBar({ onSearch, placeholder = '搜尋活動', initial = '', autoFocus }: SearchBarProps) {
  const [query, setQuery] = useState(initial);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    onSearch(query.trim());
  }

  return (
    <form onSubmit={handleSubmit} role="search" className="relative">
      <IconSearch size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-faint pointer-events-none" />
      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        autoFocus={autoFocus}
        enterKeyHint="search"
        className="h-12 w-full rounded-full bg-soft pl-11 pr-11 text-base text-ink placeholder:text-faint border border-transparent focus:bg-white focus:border-primary transition-colors"
      />
      {query && (
        <button
          type="button"
          onClick={() => { setQuery(''); onSearch(''); }}
          aria-label="清除"
          className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full inline-flex items-center justify-center text-muted"
        >
          <IconX size={16} />
        </button>
      )}
    </form>
  );
}
